import { FormFieldSelectNG } from '../../Form'
import {
  FormikField,
  getFormikFormFieldErrorProps,
  useFormikSelectFieldGetEmptyValue,
} from '../../Formik'
import { BuildingSupplierSelect } from '../BuildingSupplierSelect'

function BuildingSupplierSelectFormikField({
  Select = BuildingSupplierSelect,
  ...restProps
}) {
  const emptyValue = useFormikSelectFieldGetEmptyValue(restProps)

  return (
    <FormikField
      {...restProps}
      Component={FormFieldSelectNG}
      Select={Select}
      emptyValue={emptyValue}
      getErrorProps={getFormikFormFieldErrorProps}
    />
  )
}

export default BuildingSupplierSelectFormikField
